import { configureStore } from '@reduxjs/toolkit'
import aiWebSearchData from "./reducer/aiWebSearch"
import chatReducer from './reducer/chatSlice';
import waveflowSearchData from "./reducer/waveFlow"
import promptTestingReducer from "./reducer/promptTestingReduce"
import agentcanvaReducer from "./reducer/agentcanvas"
import protectedRoute from "./reducer/protectedRoutes"
import errorStore from "./reducer/errorStore"
import toolModelData from "./reducer/toolsmodel"
import userDetailsSlice from "./reducer/userDetails"

export const store = configureStore({
  reducer: {
    aiWebSearchData:aiWebSearchData,
    chat: chatReducer,
    waveflowSearchData:waveflowSearchData,
    promptTesting:promptTestingReducer,
    agentcanvaReducer:agentcanvaReducer,
    protectedRoute:protectedRoute,
    errorStore:errorStore,
    toolModelData:toolModelData,
    userDetails:userDetailsSlice
  }
})